import React, { useState, useEffect } from "react";
import styles from "./introSection.module.css";
import { useNavigate } from "react-router-dom";
import Dropdown from "./selectcomponent";

const IntroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTag, setActiveTag] = useState(null);
  const [searchVisible, setSearchVisible] = useState(false);
  const navigate = useNavigate();

  const handleBookAnArtistClick = () => {
    navigate("");
    const element = document.getElementById("artist-categories-container");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleJoinAsArtistClick = () => {
    navigate("/login");
  };

  const handleFindArtistClick = () => {
    switch (activeTag) {
      case "singer":
        navigate("/categories/singer");
        break;
      case "musician":
        navigate("/categories/musician");
        break;
      case "comedian":
        navigate("/categories/comedian");
        break;
      case "magician":
        navigate("/categories/magician");
        break;
      case "dancer":
        navigate("/categories/dancer");
        break;
      case "trendingArtist":
        const element = document.getElementById("trending-artist-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        break;

      case "dj":
        navigate("/categories/dj");

        break;
      case "speaker":
        navigate("/categories/speaker");
        break;
      case "videoEditor":
        navigate("/categories/video-editor");
        break;
      case "beatBoxer":
        navigate("/categories/beat-boxer");
        break;
      case "rapper":
        navigate("/categories/rapper");
        break;
      case "danceGroup":
        navigate("/categories/dance-group");
        break;

      default:
        navigate("/categories/dancer");
        break;
    }
  };

  useEffect(() => {
    setIsLoaded(true);
    const timer = setTimeout(() => {
      setSearchVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const artistTypes = [
    { id: "singers", label: "Singers", uri: "/categories/singer" },
    { id: "dancers", label: "Dancers", uri: "/categories/dancer" },
    { id: "magicians", label: "Magicians", uri: "/categories/magician" },
    { id: "bank", label: "Music Band", uri: "/categories/music-band" },
    { id: "comedian", label: "Comedian", uri: "/categories/comedian" },
    {
      id: "video_editor",
      label: "Video Editor",
      uri: "/categories/video-editor",
    },
    {
      id: "photographers",
      label: "Photographers",
      uri: "/categories/photographers",
    },
  ];

  return (
    <section className={styles.heroSection}>
      <div className={`${styles.backgroundParticle} ${styles.particle1}`}></div>
      <div className={`${styles.backgroundParticle} ${styles.particle2}`}></div>
      <div className={`${styles.backgroundParticle} ${styles.particle3}`}></div>

      <div
        className={`${styles.heroContainer} ${isLoaded ? styles.loaded : ""}`}
      >
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            <span className={styles.animatedWord}>Find</span>
            <span className={styles.animatedWord}>Your</span>
            <span className={styles.animatedWord}>Perfect</span>
            <span className={`${styles.animatedWord} ${styles.highlight}`}>
              Artist
            </span>
          </h1>

          <p className={styles.heroSubtitle}>
            Connecting talented local artists with clients who appreciate their
            craft
          </p>

          <div className={styles.categoryTags}>
            {artistTypes.map((type, index) => (
              <span
                key={type.id}
                className={`${styles.tag} ${
                  activeTag === type.id ? styles.activeTag : ""
                }`}
                style={{ animationDelay: `${0.1 * index}s` }}
                // onMouseEnter={() => setActiveTag(type.id)}
                onMouseLeave={() => setActiveTag(null)}
                onClick={() => {
                  navigate(type?.uri);
                }}
              >
                {type.label}
              </span>
            ))}
          </div>

          <div className={styles.ctaContainer}>
            <button
              className={`${styles.primaryButton} ${styles.pulseAnimation}`}
              onClick={handleBookAnArtistClick}
            >
              Book an Artist
              <svg
                className={styles.arrowIcon}
                viewBox="0 0 24 24"
                width="18"
                height="18"
              >
                <path
                  fill="currentColor"
                  d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                />
              </svg>
            </button>
            <button
              className={styles.secondaryButton}
              onClick={handleJoinAsArtistClick}
            >
              Join as Artist
            </button>
          </div>
        </div>

        <div className={styles.heroImageContainer}>
          <div className={styles.imageGrid}>
            <div
              className={`${styles.artistImage} ${styles.artistImage1}`}
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className={`${styles.artistImage} ${styles.artistImage2}`}
              style={{ animationDelay: "0.3s" }}
            ></div>
            <div
              className={`${styles.artistImage} ${styles.artistImage3}`}
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className={`${styles.artistImage} ${styles.artistImage4}`}
              style={{ animationDelay: "0.7s" }}
            ></div>
          </div>
          <div className={styles.imageBorderEffect}></div>
        </div>
      </div>

      <div
        className={`${styles.searchBarContainer} ${
          searchVisible ? styles.searchVisible : ""
        }`}
      >
        <div className={styles.searchBar}>
          <div className={styles.searchBarInner}>
            <Dropdown
              items={[
                { label: "Singer", value: "singer" },
                { label: "Musician", value: "musician" },
                { label: "Dancer", value: "dancer" },
                { label: "Magician", value: "magician" },
                { label: "Comedian", value: "comedian" },
                { label: "Trending Artist", value: "trendingArtist" },
                { label: "Dance group", value: "danceGroup" },
                { label: "DJ", value: "dj" },
                { label: "Rapper", value: "rapper" },
                { label: "Beat boxer", value: "beatBoxer" },
                { label: "Video Editor", value: "videoEditor" },
                { label: "Speaker", value: "speaker" },
              ]}
              setElement={setActiveTag}
              selectedItem={activeTag}
            />

            <button
              className={`${styles.searchButton} ${styles.shimmerEffect}`}
              onClick={handleFindArtistClick}
            >
              <span className={styles.buttonContent}>
                <svg
                  className={styles.searchIcon}
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path
                    fill="currentColor"
                    d="M21.707 20.293l-5.395-5.396A7.952 7.952 0 0016 10c0-4.411-3.589-8-8-8S0 5.589 0 10s3.589 8 8 8a7.952 7.952 0 004.897-1.688l5.396 5.395A.998.998 0 0020 22a.999.999 0 00.707-1.707zM8 16c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                  />
                </svg>
                Find Artists
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className={styles.scrollIndicator}>
        <div className={styles.mouseIcon}>
          <div className={styles.mouseWheel}></div>
        </div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default IntroSection;
